import * as R from 'ramda'

import { TypeFormats } from 'utils/format'
import { isNilOrEmpty } from 'utils/ramda'

import {
  NODE_DESCRIPTIONS,
  SANKEY_EDGE_COLOR_MAP,
  SANKEY_EDGE_TO_NODES_MAP,
} from './RoutingSankey.constants'

const EMPTY_SANKEY_NODE = { name: '' }

const guardedSum = R.pathOr(0, ['sum']) // default to 0

function formatTooltipPercentage(point: object) {
  const fromNode = R.pathOr(EMPTY_SANKEY_NODE, ['fromNode'], point)
  const weight = R.pathOr(0, ['weight'], point)

  if (!isNilOrEmpty(fromNode) && !isNilOrEmpty(weight)) {
    const percentage = (weight / guardedSum(fromNode)) * 100
    return `<span><b>${TypeFormats.PERCENT(percentage)}</b> of all ${R.toLower(
      fromNode.name
    )}<span>`
  }
}

export const formatTooltipCopy = (point: object) => {
  const isNode = R.path(['isNode'], point)
  const description = isNode
    ? NODE_DESCRIPTIONS[R.pathOr('', ['name'], point)]
    : NODE_DESCRIPTIONS[R.pathOr('', ['toNode', 'name'], point)]

  return `${description} ${
    !isNode
      ? `</br><span class="routing-sankey-tooltip-percentage">${formatTooltipPercentage(
          point
        )}<span>`
      : ''
  }`
}

const formatSankeyData = (value: string, key: string) => {
  const edges = R.pathOr([], [key], SANKEY_EDGE_TO_NODES_MAP)
  const weight = parseInt(value)
  const color = R.equals(weight, 0)
    ? 'transparent'
    : R.path([key], SANKEY_EDGE_COLOR_MAP)
  const name = key
  return R.flatten([color, edges, weight, name])
}

export const resolveSankeyData = R.pipe(
  R.head,
  R.mapObjIndexed((value: string, key: string) => formatSankeyData(value, key)),
  R.values
)

export const resolveHasAtLeastOneEdgeWithData = R.pipe(
  R.head,
  R.mapObjIndexed((value: string) => parseInt(value)),
  R.values,
  R.find((metricValue: number) => !R.equals(metricValue, 0))
)
